import { Route, Routes } from 'react-router-dom';

import OffersMain from './main';
import OfferPage from './offer';

export default function OffersPage() {
  return (
    <Routes>
      <Route element={<OffersMain />} path="" />
      <Route element={<OfferPage />} path=":offer_id/*" />
    </Routes>
  );
}
